import { Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import LinkBlock from './LinkBlock';

const useStyles = makeStyles(theme => ({
    award: {
        display: "flex",
        justifyContent: "flex-start",
        "& *": {
            transitionDuration: theme.transitions.duration.standard,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
        },
        "& .MuiButton-startIcon svg": {
            height: "auto",
        },
    },
    awardEnabled: {
        backgroundColor: theme.palette.secondary.black,
        borderColor: theme.palette.primary.main,

        "& $heading": {
            //color: "#fff",
        },
        "& .MuiButton-startIcon path": {
            fill: theme.palette.primary.main,
        },
        "& .MuiButton-endIcon": {
            color: theme.palette.primary.main,
            //backgroundColor: theme.palette.secondary.black,
        },
    },
    awardDisabled: {
        width: "100%",
        pointerEvents: "none",
        "& $heading": {
            color: theme.palette.secondary.light,
        },
        '&:hover': {
            border: "1px solid "+theme.palette.secondary.border,
            cursor: "not-allowed",
            pointerEvents: "all !important"
        },
        "& .MuiButton-endIcon": {
            color: theme.palette.secondary.light,
        },
        "& .MuiButton-startIcon path": {
            fill: theme.palette.secondary.light,
        },
    },
    heading: {
        fontWeight: theme.typography.fontWeightRegular,
        margin: 0,
        marginBottom: ".25rem",
        maxWidth: "20rem",
        textTransform: "uppercase",
    },
}));

export default function AwardLinkBlock({ number = null, minHeight = "11rem", award, ...props }) {

    const classes = useStyles();    

    const awardOpen = award.alwaysActive || Boolean(award.openForViewing && award.numEntries > 0);
    
    return (
        <LinkBlock 
            to={award.urlNextTo}
            {...(awardOpen ? {} : {component: 'div'})}
            className={`${classes.award} ${awardOpen ? classes.awardEnabled : classes.awardDisabled}`}
            style={{minHeight}}
            padding="2rem" 
            {...props}
        >
            <Typography variant="h6" className={classes.heading}>{award.title ?? ""}</Typography>
        </LinkBlock>
    );
}